import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
  en: {
    translation: {
      "sector": "Sector",
      "round": "Round",
      "pay table": "Pay Table",
      "dozens": "Dozen",
      "even odd": "Even/Odd",
      "last 5": "LAST 5 RESULTS",
      "last 120": "LAST 120 DRAWS",
      "colors": "Color",
      "even": "Even",
      "odd": "Odd",
      "under over": "Under/Over",
      "suits joker": "Suits/Joker",
      "suits": "Suits",
      "joker": "Joker",
      "number": "Number",
      "multiplay table": "MultiPlay Table",
      "suit number": "Suit x Number",
      "suit sector": "Suit x Sector",
      "suit dozen": "Suit x Dozen",
      "suit color": "Suit x Color",
      "suit eo": "Suit x Even/Odd",
      "suit uo": "Suit x Under/Over",
      "joker number": "Joker x Number",
      "joker sector": "Joker x Sector",
      "joker dozen": "Joker x Dozen",
      "joker color": "Joker x Color",
      "joker eo": "Joker x Even/Odd",
      "joker uo": "Joker x Under/Over",
      "bets closed": "THE BETS ARE CLOSED"
    }
  },
  rus: {
    translation: {
      "sector": "Sector",
      "round": "Round",
      "pay table": "Pay Table",
      "dozens": "Dozen",
      "even odd": "Even/Odd",
      "last 5": "LAST 5 RESULTS",
      "last 120": "LAST 120 DRAWS",
      "colors": "Color",
      "even": "Even",
      "odd": "Odd",
      "under over": "Under/Over",
      "suits joker": "Suits/Joker",
      "suits": "Suits",
      "joker": "Joker",
      "number": "Number",
      "multiplay table": "MultiPlay Table",
      "suit number": "Suit x Number",
      "suit sector": "Suit x Sector",
      "suit dozen": "Suit x Dozen",
      "suit color": "Suit x Color",
      "suit eo": "Suit x Even/Odd",
      "suit uo": "Suit x Under/Over",
      "joker number": "Joker x Number",
      "joker sector": "Joker x Sector",
      "joker dozen": "Joker x Dozen",
      "joker color": "Joker x Color",
      "joker eo": "Joker x Even/Odd",
      "joker uo": "Joker x Under/Over",
      "bets closed": "THE BETS ARE CLOSED"
    }
  },
  arm: {
    translation: {
    }
  },
  fas: {
    translation: {}
  },
  ukr: {
    translation: {}
  },
  por: {
    translation: {}
  },
  spa: {
    translation: {
      "sector": "SECTOR",
      "round": "RONDA",
      "pay table": "Tabla de pagos",
      "dozens": "DOCENAS",
      "even odd": "PAR/IMPAR",
      "last 5": "ÚLTIMOS 5 RESULTADOS",
      "last 120": "ÚLTIMOS 120 SORTEOS",
      "colors": "COLORES",
      "even": "PAR",
      "odd": "IMPAR",
      "under over": "MENOS DE/MÁS DE",
      "suits joker": "´PALOS/COMODÍN",
      "suits": "Palos",
      "joker": "Comodín",
      "number": "Número",
      "multiplay table": " Mesa multijuego ",
      "suit number": "Palo x Número",
      "suit sector": "Palo x Sector",
      "suit dozen": "Palo x Docena",
      "suit color": "Palo x Color",
      "suit eo": "Palo x Par/Impar",
      "suit uo": "Palo x Menos de/Más de",
      "joker number": "Comodín x Número",
      "joker sector": "Comodín x Sector",
      "joker dozen": "Comodín x Docena",
      "joker color": "Comodín x Color",
      "joker eo": "Comodín x Par/Impar",
      "joker uo": "Comodín x Menos de/Más de",
      "bets closed": "LAS APUESTAS ESTÁN CERRADAS"
    }
  },
  fre: {
    translation: {}
  },
  chn: { // Traditional
    translation: {}
  },
  zhh: {
    translation: {}
  },
  tur: {
    translation: {}
  },
  geo: {
    translation: {}
  },
  arb: {
    translation: {}
  },
  ger: {
    translation: {}
  },
  kor: {
    translation: {}
  },
  jpn: {
    translation: {}
  },
  pol: {
    translation: {}
  },
  pt_br: {
    translation: {}
  }
};

i18n.use(initReactI18next).init({
  resources, lng: "en", debug: false,
  keySeparator: false, // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

export default i18n;